export enum PrimerTypeEnum {
    STANDARD = 0,
    CUSTOM,
    SHIPPED,
    RECENT_CUSTOM,
}

export const primerTypeNames: Record<PrimerTypeEnum, string> = {
    [PrimerTypeEnum.STANDARD]: 'standard',
    [PrimerTypeEnum.CUSTOM]: 'custom',
    [PrimerTypeEnum.SHIPPED]: 'shipped',
    [PrimerTypeEnum.RECENT_CUSTOM]: 'recentCustom',
};
